import { ZoneDirection, ZoneType } from '@sparelabs/domain-logic'
import { IPoint, IPolygon } from '@sparelabs/geography'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'
// eslint-disable-next-line import/no-cycle
import { ServiceStatus, ServiceType } from './ServiceTypes'

export interface IZonePostBodyCommon {
  serviceId: string
  name: string
  direction: ZoneDirection
  type: ZoneType
  groupIds: string[]
  timeRuleId: string | null
  isVisibleToRiderApp?: boolean
  externalId?: string | null
  stopIds?: string[]
}

/**
 * @deprecated - Use IZonePostBodyZoneArea instead
 */
export interface IZonePostBodyDeprecated extends IZonePostBodyCommon {
  /**
   * @deprecated - Create/select a zoneArea and provide its id as zoneAreaId instead
   */
  area: IPolygon
}

export interface IZonePostBodyZoneArea extends IZonePostBodyCommon {
  zoneAreaId: string
}

export const isZonePostBodyDeprecated = (body: IZonePostBody): body is IZonePostBodyDeprecated => 'area' in body
export const isZonePostBody = (body: IZonePostBody): body is IZonePostBodyZoneArea => 'zoneAreaId' in body

export type IZonePostBody = IZonePostBodyDeprecated | IZonePostBodyZoneArea

export type IZonePatchBody = Partial<IZonePostBodyCommon> & {
  /**
   * @deprecated - Create/select a zoneArea and provide its id as zoneAreaId instead
   */
  area?: IPolygon
  zoneAreaId?: string
}

export interface IZoneResponse extends IModelJsonValues, Required<IZonePostBodyCommon> {
  id: string
  area: IPolygon
  zoneAreaId: string
}

export interface IZoneListQueryParams extends IListModelQueryParamValues {
  serviceId?: string
  serviceIds?: string[]
  direction?: ZoneDirection
  type?: ZoneType
  serviceType?: ServiceType
  serviceStatus?: ServiceStatus | ServiceStatus[]
  timeRuleId?: string
  isVisibleToRiderApp?: boolean
  zoneAreaId?: string
}

export interface IOrganizationZonesCentroidResponse {
  centroidPoint: IPoint | null
  centroidRadius: number | null
}
